import * as React from "react";
import { cn } from "../../lib/utils";
import { Sparkline } from "../sparkline";

function getAutoGridClass(count) {
  if (count <= 1) return "grid-cols-1";
  if (count === 2) return "grid-cols-1 sm:grid-cols-2";
  if (count === 3) return "grid-cols-1 sm:grid-cols-3";
  if (count === 4) return "grid-cols-2 lg:grid-cols-4";
  return "grid-cols-2 md:grid-cols-3 lg:grid-cols-5";
}

/**
 * Dense joined stat row (admin hub pattern). Uses design tokens only.
 * Fluid auto-fit container query layout with truncation on overlines and values.
 */
const StatStrip = React.forwardRef(
  ({ className, items = [], columnsClassName, sparklineData, ...props }, ref) => {
    const autoGridClass = columnsClassName || getAutoGridClass(items?.length ?? 0);

    return (
      <div
        ref={ref}
        className={cn(
          "@container grid gap-px overflow-hidden rounded-card border border-border bg-border",
          autoGridClass,
          className,
        )}
        {...props}
      >
        {items.map((item, idx) => {
          const Icon = item.icon;
          const rawSeries =
            item.sparklineData ||
            item.sparkline ||
            item.series ||
            (Array.isArray(sparklineData) ? sparklineData[idx] : undefined);
          const hasSeries = Array.isArray(rawSeries) && rawSeries.length > 0;

          return (
            <div
              key={item.label}
              className="flex min-w-0 items-center justify-between gap-3 bg-card px-2 py-2 sm:px-3.5 sm:py-3.5 sm:flex-col sm:items-start sm:justify-center"
            >
              <div className="flex min-w-0 max-w-full items-center justify-between w-full">
                <div className="flex min-w-0 max-w-full items-center gap-1.5 text-muted-foreground">
                  {Icon ? (
                    <Icon className="h-3.5 w-3.5 shrink-0 opacity-70" />
                  ) : null}
                  <span
                    className="truncate text-overline-medium tracking-wider"
                    title={typeof item.label === "string" ? item.label : undefined}
                  >
                    {item.label}
                  </span>
                </div>
                {hasSeries && (
                  <div className="hidden sm:block w-14 shrink-0">
                    <Sparkline
                      data={rawSeries}
                      color={item.sparklineColor || "var(--color-success, #10b981)"}
                      height={18}
                      width="100%"
                      showDot={false}
                    />
                  </div>
                )}
              </div>
              <div className="flex items-center justify-between w-full gap-2">
                <p
                  className="w-full truncate text-lg font-semibold tabular-nums text-foreground sm:text-xl"
                  title={
                    typeof item.value === "string" || typeof item.value === "number"
                      ? String(item.value)
                      : undefined
                  }
                >
                  {item.value}
                </p>
                {hasSeries && (
                  <div className="sm:hidden w-16 shrink-0">
                    <Sparkline
                      data={rawSeries}
                      color={item.sparklineColor || "var(--color-success, #10b981)"}
                      height={18}
                      width="100%"
                      showDot={false}
                    />
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    );
  },
);
StatStrip.displayName = "StatStrip";

export { StatStrip };


